import { render, staticRenderFns } from "./ValkyrieGraphLegend.vue?vue&type=template&id=0551b23c&scoped=true&"
import script from "./ValkyrieGraphLegend.vue?vue&type=script&lang=js&"
export * from "./ValkyrieGraphLegend.vue?vue&type=script&lang=js&"
import style0 from "./ValkyrieGraphLegend.vue?vue&type=style&index=0&id=0551b23c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0551b23c",
  null
  
)

export default component.exports